var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Styled } from './style';
import imagePlaceholder from './img/img_thumb_placeholder.png';
var Thumbnail = /** @class */ (function (_super) {
    __extends(Thumbnail, _super);
    function Thumbnail(props) {
        var _this = _super.call(this, props) || this;
        _this.imgRef = React.createRef();
        return _this;
    }
    Thumbnail.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.src !== nextProps.src;
    };
    Thumbnail.prototype.componentDidUpdate = function () {
        this.loadSrc();
    };
    Thumbnail.prototype.componentDidMount = function () {
        this.loadSrc();
    };
    Thumbnail.prototype.loadSrc = function () {
        var _this = this;
        var previewImg = new Image();
        previewImg.src = this.props.src || '';
        previewImg.onload = function () {
            if (_this.imgRef.current) {
                _this.imgRef.current.src = _this.props.src;
            }
        };
        previewImg.onerror = function () {
            if (_this.imgRef.current) {
                _this.imgRef.current.src = imagePlaceholder;
            }
        };
    };
    Thumbnail.prototype.render = function () {
        var _a = this.props, overlay = _a.overlay, size = _a.size;
        return (React.createElement(Styled, { className: "thumbnail" },
            React.createElement("div", { className: "wrapper" },
                React.createElement("img", { ref: this.imgRef, src: this.props.src, className: size }),
                overlay && React.createElement("div", { className: "overlay" }, overlay))));
    };
    return Thumbnail;
}(React.Component));
export default Thumbnail;
//# sourceMappingURL=index.js.map